import React, { useEffect } from "react"
import { Container } from "@material-ui/core"
import { useLocation } from "react-router-dom";
import { logPageView } from "gtag";

function App(props) {
  const location = useLocation();

  useEffect(() => {
    updateWindowSize()
    window.addEventListener('resize', () => {
      updateWindowSize()
    });
  }, []);

  useEffect(() => {
    logPageView(location.pathname)
  }, [location]);

  return (
    <Container style={{ width: "100%", height: "calc(var(--vh, 1vh) * 100)", padding: 0 }}>{props.children}</Container>
  )
}

function updateWindowSize() {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

export default App
